<template>
  <router-link :to="{
    name: 'ModelPage',
    params: { locale, name: slug }
  }">
    <div class="model-list__item">
      <div class="model-list__image">
        <picture>
          <img :class="opac" :src="image" :alt="name" width="496" height="364" loading="lazy"/>
        </picture>
      </div>
      <div class="model-list__info">
        <h3 class="model-list__title" v-text="name"></h3>
        <a :href="`/${locale}/modelos/${slug}`" class="link">
          {{ translate.seePhotoShoot }} <i class="icon-arrow-right"></i>
        </a>
      </div>
      <div style="height: 20px">&nbsp;</div>
    </div>
  </router-link>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'

export default {
  name: 'ModelListItem',
  props: {
    mobileImage: null,
    image: null,
    name: null,
    slug: null
  },
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return this.legends.portugues
      }

      return this.legends.ingles
    }
  },
  data() {
    return {
      legends: {
        portugues: {
          seePhotoShoot: 'Veja o ensaio'
        },
        ingles: {
          seePhotoShoot: 'Show essay'
        }
      },
      opac: 'opacity-0'
    }
  },
  mounted() {
    this.opac = 'opacity-1'        
  }      
}
</script>

<style scoped></style>
